module.exports = __webpack_public_path__ + "static/img/img-tec-model-00.f573b27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-tec-model-00.png
// module id = j4bA
// module chunks = 1